/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Header, PaymentCard } from "../../components";
import { CircleCheck } from "../../assets/svgs";
import { getPaymentCardDate, getOrdinal } from "../../utils";
import { PAYMENT_STATUS } from "../../constants";
import useApp from "../../hooks/useApp";
import useNavigateWithQuery from "../../hooks/useNavigateWithQuery";
import "./styles.scss";

const CompletedPayments = () => {
  const navigate = useNavigateWithQuery();
  const location = useLocation();
  const { t } = useTranslation();
  const { financeDetails, getFinanceApplications } = useApp();
  const { financeApplicationId } = location.state || {};

  const [completedPayments, setCompletedPayments] = useState([]);

  useEffect(() => {
    const completedInstallments = financeDetails?.installments?.filter(
      installment => installment.status === PAYMENT_STATUS.PAID
    );
    setCompletedPayments(completedInstallments);
  }, [financeDetails]);

  useEffect(() => {
    getFinanceApplications(financeApplicationId);
  }, []);

  return (
    <div className="completed-payments-container">
      <Header backEnable onClick={() => navigate(-1)} />
      <div className="completed-payments-content-container">
        <h1 className="completed-payments-container-title">
          {t("completed_payments.completed_payments")}
        </h1>
        {completedPayments?.map(installment => {
          const date = getPaymentCardDate(installment.due_date);
          const ordinal = getOrdinal(installment.installment_number);
          return (
            <PaymentCard
              key={installment.id}
              dataContainerBgColor={"bg-neutral-100"}
              statusContainerBgColor={"bg-success-50"}
              dayTextColor={"text-neutral-900"}
              monthTextColor={"text-neutral-600"}
              paymentStatusTextColor={"text-success-600"}
              dayText={date.day}
              monthText={date.month}
              paymentPeriodText={`${ordinal} ${t(
                "completed_payments.payment"
              )}`}
              paymentAmountText={installment.formatted_amount_due}
              icon={CircleCheck}
              paymentStatusText={t("global.paid")}
              isRounded={true}
            />
          );
        })}
      </div>
    </div>
  );
};

export default CompletedPayments;
